document.addEventListener('DOMContentLoaded', function() {
const tabsNav = document.getElementById('tabhNav');
const tabLinks = document.querySelectorAll('.tabh-nav a');
const tabContents = document.querySelectorAll('.tabh-content');
const offsetTop = tabsNav.offsetTop;
let topHeight=document.querySelector('#header-group').offsetHeight + document.querySelector('.product-information').offsetHeight;
   
// 监听滚动事件
window.addEventListener('scroll', function() {
    // 固定tabs导航栏
    if (window.pageYOffset >= offsetTop+topHeight) {
        tabsNav.classList.add('fixed');
    } else {
        tabsNav.classList.remove('fixed');
    }
    
    // 高亮当前可见的tab
    let currentTab = '';
    tabContents.forEach(content => {
        const contentTop = content.offsetTop+topHeight;
        const contentHeight = content.offsetHeight;        
        if (window.pageYOffset >= contentTop - 100 && 
            window.pageYOffset < contentTop + contentHeight - 100) {
            currentTab = content.id;
        }
    });
    
    if (currentTab) {
        tabLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${currentTab}`) {
                link.classList.add('active');
            }
        });
    }
});

// 点击切换tab并滚动到对应内容
    tabLinks.forEach(link => {
      link.addEventListener('click', () => {
        tabLinks.forEach(i => i.classList.remove('active'));
        link.classList.add('active');
        const targetId = link.getAttribute('href');
        document.querySelector(targetId).scrollIntoView({ behavior: 'smooth' });
      });
    });  
   document.getElementById('tab-ship').style.display = 'block';document.getElementById('tab-faq').style.display = 'block';

//FAQ accordion 
      const qs = document.querySelectorAll('#accordion-box .item-title');
      qs.forEach(q => {
        q.addEventListener('click', () => {
          const a = q.nextElementSibling;
          if (a.style.maxHeight) {
            a.style.maxHeight = null;
          } else {
            a.style.maxHeight = a.scrollHeight + 'px';
          }
        });
      });
      if (qs.length > 0) {
        const i = qs[0].nextElementSibling;
        i.style.maxHeight = i.scrollHeight + 'px';
      }

  const getSideMenu = async() => {
    const response = await fetch(Shopify.routes.root+'?view=sidebarcategories');
    const data = await response.text()
    document.getElementById('product-side-menu').innerHTML=data;
  }
  getSideMenu();

});

window.addEventListener('load', function() {
  function loadIframe(width,height) {
  let e=document.getElementById('video-iframe');
  if(e){
    let src = e.dataset.vurl;
    let i = document.createElement('iframe');i.src = src;i.width = width;i.height = height;i.frameborder=0;i.allowfullscreen;  
     if (!document.querySelector(`iframe[src="${src}"]`)) {       
        e.appendChild(i);
    }   
 }
}
loadIframe('100%','480');
});
